"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetProductListingFacets = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationHttp = require("@ori/presentation-http");
var _react = require("react");
var _api = require("../../../api");
/* istanbul ignore file @preserve */ const useGetProductListingFacets = (param)=>{
    let { pageId } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers } = (0, _presentationHttp.useHeaders)();
    const previewMode = (0, _react.useMemo)(()=>(0, _editorialFetching.getPreviewMode)(), []);
    const getFacets = (0, _react.useCallback)(async (values)=>{
        const response = await (0, _api.getProductListingFacets)({
            graphQlUrl: graphQlNetUrl,
            headers,
            pageId,
            facetFiltering: values,
            previewMode
        });
        return response;
    }, [
        graphQlNetUrl,
        headers,
        pageId,
        previewMode
    ]);
    return {
        getFacets
    };
};
exports.useGetProductListingFacets = useGetProductListingFacets;
